import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function NewFolderDialog(props) {
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>Add New Folder</DialogTitle>
      <DialogContent>
        <DialogContentText>Type the name of the new folder.</DialogContentText>

        <TextField
          autoFocus
          required
          margin="dense"
          id="FolderName"
          name="FolderName"
          label="Folder Name"
          maxlength={30}
          type="text"
          fullWidth
          variant="standard"
          value={props.newFolderName}
          onChange={props.onTextChange}
        />
      </DialogContent>
      <DialogActions>
        <Button startIcon={<ArrowBackIcon />} onClick={props.onClose}>
          Cancel
        </Button>

        <Button
          form="subscription-form"
          startIcon={<SaveIcon />}
          variant="contained"
          disabled={
            props.isLoading
              ? true
              : props.newFolderName.length === 0
              ? true
              : false
          }
          onClick={props.onCreateFolderSave}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
